import { handleApi } from "./api";
import { ApiGateWayEndPoint, definedRouteTypes, definedApiMethods } from ".";

const delete_entry = async (body) => {
    const url = `${ApiGateWayEndPoint}/${definedRouteTypes.delete}`;
    const resp = await handleApi(url, definedApiMethods.delete, body);
    return resp;
  };
  
  export default delete_entry;